module.exports = __webpack_public_path__ + "img/079-wind-sign.3d0a5e84.svg";